import { Component, OnInit } from '@angular/core';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-dropdowns-with-rules-dropdown',
  templateUrl: '../template-dropdown.html',
})
export class DropdownsWithRulesDropdownComponent extends DropdownBaseComponent implements OnInit {

  constructor(
    private readonly dropdownService: DropDownService,
    protected readonly translatorService: TranslatorService
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);
    this.itemsData = [
      { id: true, name: this.translatorService.trans('dropdown-with-rule.true') },
      { id: false, name: this.translatorService.trans('dropdown-with-rule.false') },
    ];
  }

}
